import { useEffect } from 'react';
import { useTheme } from '@mui/material';
import { EdgeToEdge } from '@capawesome/capacitor-android-edge-to-edge-support';
import { shouldApplyEdgeToEdgeFix, isAndroidPlatform } from '@ocx/utils-device';

export const useSetEdgeToEdgeBackgroundColor = () => {
  const theme = useTheme();

  useEffect(() => {
    const setEdgeToEdgeBackgroundColor = async () => {
      if (await shouldApplyEdgeToEdgeFix()) {
        // EdgeToEdge plugin enabled by default, it is not required to call enable method.
        // EdgeToEdge.enable();
        EdgeToEdge.setBackgroundColor({ color: theme.palette.primary.main });
      } else if (isAndroidPlatform()) {
        // Because EdgeToEdge plugin is enabled by default on Android, we need to disable it for devices that do not require the fix.
        // Some android versions may have issues with the plugin enabled. (API level <=29 for example, see OCST-20208 ticket)
        EdgeToEdge.disable();
      }
    };

    setEdgeToEdgeBackgroundColor();
  }, [theme.palette.primary.main]);
};
